<template>
    <div class="mt-8" style="min-height:400px;">
      <div class="grid grid-cols-1 grid-rows-auto gap-4">
        <div>
          <label class="block mb-2">Warehouse</label>
          <v-select id="warehouse" v-model="warehouse_id" class="tailwind-v-select" placeholder="Default" label="name" :reduce="itm => itm.id" @input="loadProducts" :options="[{name: 'Default', id: null}].concat(warehouses)">
          </v-select>
        </div>

        <div class="grid grid-cols-4 gap-2 items-end">
          <div class="col-span-3">
            <label class="block mb-2">Item</label>
            <v-select :filter="fuseSearch" :disabled="!items.length" id="item" v-model="selectedItem" class="tailwind-v-select" label="description" :options="items">
              <template v-slot:option="option">
                <span v-if="!option.active" class="inline-block h-2 w-2 rounded-full text-white shadow-solid bg-orange-400 mr-2" />
                <span v-if="!option.available && option.active" class="inline-block h-2 w-2 rounded-full text-white shadow-solid bg-gray-400 mr-2" />
                <span v-if="option.active && option.available" class="inline-block h-2 w-2 rounded-full text-white shadow-solid bg-green-400 mr-2" />
                {{ option.description }} - <span class="text-xs text-gray-500 font-sans">{{ option.item_code }}</span>
              </template>
            </v-select>
          </div>
          <div>
          <button class="btn-primary" :disabled="Object.keys(selectedItem).length === 0" @click="selectItem">Select</button>
          </div>
        </div>
      </div>

      <div v-for="(item, index) in selectedItems" class="bg-white overflow-hidden overflow-hidden shadow rounded-lg mt-2">
        <div class="px-3 py-3 sm:px-3">
            <div class="text-xs mt-2 font-bold leading-4 text-gray-600">
                {{ item.product.description }}
            </div>

          <div class="flex text-xs justify-between">
            <div class="leading-4 font-medium">
              {{ item.product.brand }}
            </div>
            <div>
              <span v-if="item.product.active && item.product.available" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-green-400 mr-2" /> Available</span>
              <span v-if="!item.product.available && item.product.active" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-gray-400 mr-2" /> Not Available</span>
              <span v-if="!item.product.active" class="font-medium inline-flex items-center"><span class="block h-2 w-2 rounded-full text-white shadow-solid bg-orange-400 mr-2" /> Inactive</span>
            </div>
          </div>

          <div class="flex mt-2 justify-between text-xs text-gray-500">
            <span>{{ item.product.item_code }}</span>
            <span>WCODE: {{ item.product.wcode }} ( {{ item.product.wcode_name }} )</span>
          </div>


        </div>
        <div class="border-t border-gray-200 px-3 py-2 sm:px-2">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-2 items-center">
            <select-input :errors="errors[`items.${index}.unit`]" label="Unit" inline v-model="item.unit" class="mr-2">
              <option v-for="(details, unit) in item.product.units" :value="unit">{{ unit }}</option>
            </select-input>

            <text-input :errors="errors[`items.${index}.qty`]" type="number" inline label="Quantity" v-model.number="item.qty"></text-input>

            <div>
              <label><input v-model="item.free_item" type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" /> Free Item</label>
            </div>

            <div class="ml-auto">
              <button class="btn-red" @click="removeItem(index)">Remove</button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <loading-button v-if="selectedItems.length" class="btn-primary" :loading="adding" @click="addProduct">Add</loading-button>
      </div>

    </div>
</template>
<script>
  import VSelect from 'vue-select'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import Fuse from "fuse.js"

  export default {
    name: 'AddItemModal',
    components: {LoadingButton, SelectInput, TextInput, VSelect},

    props: {
      warehouses: Array,
      orderId: Number
    },

    watch: {
      selectedItem: function (val) {
        this.unit = val.base_unit
      }
    },

    mounted() {
      this.loadProducts(null)
    },

    data() {
      return {
        items: [],
        selectedItems: [],
        warehouse_id: null,
        selectedItem: {},
        adding: false,
        errors: {}
      }
    },

    methods: {

      fuseSearch(options, search) {
        const fuse = new Fuse(options, {
          keys: ["description", "item_code"],
          shouldSort: true
        });
        return search.length
          ? fuse.search(search).map(({ item }) => item)
          : fuse.list;
      },

      removeItem(index) {
        this.selectedItems.splice(index, 1)
      },

      selectItem() {
        let item = {product: Object.assign({}, this.selectedItem), qty: null, unit: this.selectedItem.base_unit, free_item: false}
        this.selectedItems.push(item)
        this.selectedItem = {}
      },

      loadProducts(warehouse_id) {
        let url;
        if (warehouse_id) {
          url = this.route('admin.list-available-products') + '?warehouse_id=' + warehouse_id
        } else {
          url = this.route('admin.list-available-products')
        }
        this.$http.get(url).then(response => {
          if (response.data.length) {
            this.items = response.data
          } else {
            this.items = []
          }
        })
      },

      addProduct() {
        this.adding = true;

        let data = this.selectedItems

        this.$http.post(this.route('ajax.customer.orders.add-item', this.orderId),{items: data})
          .then(response => {
            this.adding = false
            this.errors = {}
            this.$emit('itemAdded')
        }).catch(err => {
          if (err.response.status === 422) {
            this.errors = err.response.data.errors
          } else {
            alert(err.response.data.message);
          }
          this.adding = false
          this.$emit('closeModal')
        })
      }
    }
  }
</script>
